import React from 'react';
import { Grid, Table, Segment, Message, Image } from 'semantic-ui-react';
import { Helmet } from 'react-helmet';
import { S3_BASE_URL } from '../../config/API';

const VMDetails = ({ vmId, loading, details, vmDetails }) => {
  // console.log('---------------> vm slots ---', details);
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <Grid centered padded style={{ marginTop: '0px', padding: '10vh' }}>
      <Helmet>
        <title>  Vending Machine Slot Items </title>
      </Helmet>
      <Grid.Row centered>
        <Grid.Column width={4} textAlign="center">
          <h2
            style={{
              fontWeight: 400,
              marginBottom: '1em',
              border: '1px solid #555',
              textAlign: 'center',
              color: '#555',
              padding: '0.5em'
            }}
          >
            Vending Machine Slot Items
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={4} textAlign="center">
          <h3 style={{ fontWeight: '400', marginTop: '-1em', color: '#555' }}>
            Details of VM : {vmDetails && vmDetails.name}, {vmDetails && vmDetails.city}
          </h3>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row centered>
        <Grid.Column width={14}>
          {details && details.length ? (
            details.map((el, i) =>
                (el.length ? (
                  <Table key={i} celled>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell>Slot ID</Table.HeaderCell>
                        <Table.HeaderCell>Code [MV ID]</Table.HeaderCell>
                        <Table.HeaderCell>Name</Table.HeaderCell>
                        <Table.HeaderCell>Active + Hold Count</Table.HeaderCell>
                        <Table.HeaderCell>Slot Capacity</Table.HeaderCell>
                        <Table.HeaderCell>Offer Price</Table.HeaderCell>
                        <Table.HeaderCell>MRP</Table.HeaderCell>
                        <Table.HeaderCell>Has Secondary</Table.HeaderCell>
                        <Table.HeaderCell>Meal Type</Table.HeaderCell>
                        <Table.HeaderCell>Image</Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {el &&
                        el.length &&
                        el.map(item => (
                          <Table.Row key={item.itemId}>
                            <Table.Cell>{item.slot_identifier}</Table.Cell>
                            <Table.Cell>{item.manufacturer_variant_id}</Table.Cell>
                            <Table.Cell>{item.itemName}</Table.Cell>
                            <Table.Cell>{`${item.active_count} + ${item.hold_count}`}</Table.Cell>
                            <Table.Cell>{item.slot_capacity}</Table.Cell>
                            <Table.Cell>Rs. {item.offer_price}</Table.Cell>
                            <Table.Cell>Rs. {item.mrp}</Table.Cell>
                            <Table.Cell>{item.secondaryItems.length ? 'Yes' : 'No'}</Table.Cell>
                            <Table.Cell>{item.mealType}</Table.Cell>
                            <Table.Cell>
                              {item.image_id && (
                                <Image
                                  style={{ height: '80px', width: '150px' }}
                                  src={`${S3_BASE_URL}/${item.image_id}`}
                                />
                              )}
                            </Table.Cell>
                          </Table.Row>
                        ))}
                    </Table.Body>
                  </Table>
                ) : null))
          ) : (
            <Message
              icon="info"
              color="yellow"
              header="Not Found"
              content="Seems like the Vending Machine Id is invalid or there is no record available"
            />
          )}
          <br />
          <br />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default VMDetails;



// WEBPACK FOOTER //
// ./src/Modules/VMDetails/component.jsx